:host {
  display: block;
  position: fixed;
  right: 12px;
  bottom: 12px;
  @include layerIndex('float');
}

:host(.with-wk-banner) {
  @media screen and (max-width: 1850px) {
    bottom: 100px;
    @media screen and (min-width: 1800px){
      right: 6em;
    }
    @media screen and (min-width: 1750px) and (max-width: 1800px) {
      right: 5em;
    }
    @media screen and (min-width: 1700px) and (max-width: 1750px) {
      right: 4em;
    }
    @media screen and (min-width: 1650px) and (max-width: 1700px) {
      right: 3em;
    }
    @media screen and (min-width: 1625px) and (max-width: 1650px) {
      right: 2em;
    }
  }
}

.backtotop {
  display: none;
  bottom: 10%;
  pointer-events: all;
  &.show {
    display: block;
  }
}
